export async function getRelatedPosts(post) {
  try {
    // console.log(post)
    let queryString = "?";
    if (post.tags.length > 0) {
      queryString += post?.tags?.map((tag) => `tags_like=${tag}`).join("&");
      queryString += `&id_ne=${post.id}`;
    }

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/blogs${queryString}`
    );
    const posts = await response.json();

    return posts;
  } catch (error) {
    console.error(error);
  }
}
